import { useMemo } from 'react';
import { AMP_SETTINGS } from '@ampsec/platform-client';
import { useTenantSettings } from './useTenantSettings';

const parseBooleanSetting = (value: unknown, fallback: boolean): boolean => {
    if (typeof value === 'boolean') {
        return value;
    }
    if (typeof value === 'string') {
        return value.toLowerCase() === 'true';
    }
    return fallback;
};

export const useAskAmpyEnabled = (): { isAskAmpyEnabled: boolean; isLoading: boolean } => {
    const { tenantSettings, settingsLoading } = useTenantSettings();

    return useMemo(() => {
        const askAmpySetting = AMP_SETTINGS.tenant.SECURITYHUB_ASK_AMPY_ENABLED;
        const rawValue = tenantSettings?.[askAmpySetting.id]?.value;
        const isAskAmpyEnabled = parseBooleanSetting(rawValue, askAmpySetting.defaultValue);

        return {
            isAskAmpyEnabled,
            isLoading: settingsLoading,
        };
    }, [tenantSettings, settingsLoading]);
};

